import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_GROWTH_EMBED_SIGN_PETITION_FORM_EXPERIMENT = defineFcm(
	'supporter_growth_embed_sign_petition_form_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'Petition Details Page Sign Form',
		description:
			'Experiment for mobile devices to display an embed version of the sign form in the page and have the Sign Petition CTAs scroll to it when clicked: https://change.atlassian.net/browse/CHANGE-84098',
		import: false,
		template: {
			experimentName: '',
		},
	});
